import { h, Fragment } from 'preact';
import { useContext } from 'preact/hooks';
import ChatIcon from 'widget_main/components/ChatIcon';
import { SettingsContext, ChatAvailabilityContext } from 'widget_main/store';
import { getHTMLFromMarkdown } from 'widget_main/components/Markdown/helpers';
import Markdown from 'widget_main/components/Markdown/Markdown';
import styles from './conversationsHeader.scss';

const ConversationsHeader = () => {
  const chatAvailability = useContext(ChatAvailabilityContext);
  const chatSettings = useContext(SettingsContext);
  const greeting = chatSettings?.greeting;

  const renderSubText = () => {
    if (chatAvailability === 'online') {
      return (
        <Fragment>
          {greeting && (
            <span class={styles.greeting}>
              <Markdown
                markdown={getHTMLFromMarkdown(greeting, { breaks: true })}
              />
            </span>
          )}
        </Fragment>
      );
    }

    return (
      <span className={styles.greeting}>
        <Markdown
          markdown={getHTMLFromMarkdown(chatSettings?.offhoursMessage, {
            breaks: true,
          })}
        />
      </span>
    );
  };

  return (
    <div class={styles.conversationsHeader}>
      <div class={styles.content}>
        <ChatIcon
          className={styles.chatIconWrapper}
          size={{ width: 50, height: 50 }}
        />
        <div className={styles.text}>
          <h1 class={styles.teamName}>{chatSettings?.teamName}</h1>
          {renderSubText()}
        </div>
      </div>
    </div>
  );
};

export default ConversationsHeader;
